// import Vue from 'vue'
// import Vuex from 'vuex'
// import getters from './getters'

// Vue.use(Vuex)
// // https://webpack.js.org/guides/dependency-management/#requirecontext
// const modulesFiles = require.context('./modules', true, /\.js$/)

// // 不需要 './modules/app'`
// // 它将自动要求所有vuex模块从模块文件
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})

// const store = new Vuex.Store({
//   modules,
//   getters
// })

// export default store

import { createStore } from 'vuex'

export default createStore({
	state: {
		user: {
			usKey: window.localStorage.getItem('usKey') || null,
			userInfo: !window.localStorage.getItem('userInfo') ? null : JSON.parse(window.localStorage.getItem('userInfo')) || null,
			userId: window.localStorage.getItem('userId') || null,
			userData: {
				fileImg: '',
				head_img: '',
				birthday: '',
				email: '',
				sex: '',
				nick_name: '',
				virtualuser_id: ''
			}
		},
		login: {
			registerType: 0, // 0 邮箱验证码登录 1 手机号验证码登录 2 邮箱密码登录 3 手机号密码登录
			account_no: '', // 账号 手机号或邮箱
			vf_code: '', // 验证码
			passwordLogin: 0, // 0验证码登录 1密码登录
			password: ''
		},
		websocket: {
			websocketMsg: null,
			heartCheckMsg: null, // 心跳
		}
	},
	getters: {
		
	},
	mutations: {
		
	},
	actions: {
		
	},
	modules: {
		
	}
})
